module.exports = __webpack_public_path__ + "static/img/banner.0ca068d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/ability/img/banner.png
// module id = 8Y2c
// module chunks = 1